import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
import ThriveRect from "../../images/mobileImages/thriverectangle.svg";
import BlogRectangle77 from "../../images/BlogRectangle77.svg";
import RightVector from "../../images/icons/RightVector.svg";
import LeftVector from "../../images/icons/LeftVector.svg";

const videoSources = [
  "https://ak03-video-cdn.slidely.com/promoVideos/videos/64/2a/642adecda3f09b37d2590fc2/final.mp4?dv=2",
  "https://www.youtube.com/embed/7ObGwvZ-ErI",
]

const ServicesContainer = styled.div`
  display: flex;
  width: 100%;
  height: 850px;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
  background: url(${BlogRectangle77}) no-repeat;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: ${deviceSize.laptop}px) {
    padding: 174px 260px 151px 181px;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    padding: 0 0 0 0;
    width: 100%;
    background-size: contain;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    height: 100%;
    width: 100%;
    background: url(${ThriveRect}) no-repeat;
    background-size: cover;
    padding-bottom: 10%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 100%;
    height: 100%;
  }
`;

const ServicesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  gap: 5%;

  @media screen and (max-width: ${deviceSize.laptop}px) {
    padding: 0 30px;
    gap: 16px;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 89%;
    gap: 12px;
    padding: 20px 0px;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    gap: 40px;
  }
`;

export const EmployeeCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 50px;
  max-height: 340px;
  width: 65%;
  padding: 40px;
  border: 2px solid #9d2222;
  transition: all 0.2s ease-in-out;
  stroke: solid #9d2222;
  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media screen and (max-width: ${deviceSize.tablet}) {
    width: 85%;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 95%;
    padding: 20px;
  }
  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 303px;
    height: 175px;
    /* margin-top: 10%;
    margin-bottom: 10%; */
    justify-content: center;
    order: 4;
  }
`;

const VideoCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    height: 175px;
    justify-content: center;
  }
`;

const Arrow = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 40px;
  height: 40px;


  &.left {
    left: 20%;
  }

  &.right {
    right: 20%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 30px;
    height: 30px;

    &.left {
      left: 1%;
    }

    &.right {
      right: 1%;
    }
  }
`;

const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 100%;
  position: relative;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    width: 80%;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  width: 100%;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${({ currentIndex }) => -currentIndex * 100}%);
  width: 100%;
`;

const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
`;

const IframeElement = styled.iframe`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
`;

export const TestimonialCard = styled.div`
  width: 432px;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 75%;
  }
`;

const ServiceCardTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  place-self: flex-end;
  padding-bottom: 5%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 200px;
    place-self: center;
    padding-top: 5%;
    /* height: 50%; */
  }
`;

export const ServicesIcon = styled.img`
  width: 90px;
  height: 90px;
  flex-grow: 0;
  align-items: center;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
  }
`;

const ThriveH1 = styled.h1`
  width: 100%;
  margin: 44px 0 24px 0;
  font-family: Sunflower;
  font-size: 38px;
  font-weight: 500;
  text-align: center;
  color: #9d2222;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 20px;
    width: 200px;
    margin: 0;
  }
`;

const ThriveP = styled.p`
  font-family: "Roboto", "Helvetica", "arial";
  font-style: italic;
  font-size: 1.3em;
  width: 100%;
  text-align: center;
  color: #4a4a4a;
  word-wrap: break-word;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 13px;
    width: 200px;
    margin: 0;
  }
`;


export const NameHead = styled.h3`
  font-family: "Sunflower";
  font-size: 15px;
  width: 150px;
  color: #9d2222;
  flex-grow: 0;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  align-items: center;
  word-break: normal;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    font-size: 80%;
    width: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 59px;
    height: 15px;
    font-size: 12px;
  }
`;

export const PositionP = styled.p`
  height: 14px;
  flex-grow: 0;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #9d2222;
  align-items: center;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 45px;
    height: 12px;
    font-size: 10px;
  }
`;

export const TitleHead = styled.h3`
  width: 200px;
  height: 32px;
  flex-grow: 0;
  font-family: "Sunflower";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d2222;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    font-size: 85%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 144px;
    height: 38px;
    font-size: 15px;
  }
`;

export const DescriptionP = styled.p`
  width: 183px;
  height: 48px;
  flex-grow: 0;
  font-family: "Sunflower";
  font-size: 13px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 162px;
    height: 42px;
    font-size: 11px;
  }
`;

export const SectionsIcon = styled.div`
  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 40%;
  }

  @media screen and (max-width: 768px){
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Line_282 = styled.div`
  width: 1px;
  flex-grow: 0;
  margin: 1px 24px 0 30px;
  border-left: 2px solid #9d2222;
  height: 140px;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin: 1px 11px 0 15px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2%;
`;

export const Dot = styled.span`
  height: 12px;
  width: 12px;
  margin: 0 5px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  
  &.active {
    background-color: #717171;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    height: 10px;
    width: 10px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    height: 8px;
    width: 8px;
  }
`;


export function Services() {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRefs = useRef([]);

  const handleNextVideo = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videoSources.length);
  };

  const handlePreviousVideo = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? videoSources.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setCurrentVideoIndex(index);
  };


  useEffect(() => {
    const currentVideoRef = videoRefs.current[currentVideoIndex];
    if (currentVideoRef) {
      currentVideoRef.load();
    }
  }, [currentVideoIndex]);

  return (
    <ServicesContainer id="Ourstrenght">
      <ServicesWrapper id="wrapper">
        <ServiceCardTitle>
          <ThriveH1>Thrive With Expedient</ThriveH1>
          <ThriveP>
            Discover how we bolster the growth <br />
            of our employees.
          </ThriveP>
        </ServiceCardTitle>
        <VideoCard id="video-card">
          <Arrow id="arrow-left"
            src={LeftVector}
            alt="previous"
            className="left"
            onClick={handlePreviousVideo}
          />
          <VideoWrapper id="video-wrapper">
            <VideoContainer currentIndex={currentVideoIndex}>
              {videoSources.map((src, index) => (
                <div key={index} style={{ width: "100%", flexShrink: 0 }}>
                  {src.includes("youtube") ? (
                    <IframeElement
                      src={src}
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <VideoElement
                      ref={(el) => (videoRefs.current[index] = el)}
                      controls
                      disablePictureInPicture
                      controlsList="nodownload"
                      muted
                    >
                      <source src={src} type="video/mp4" />
                      Sorry, your browser doesn't support videos.
                    </VideoElement>
                  )}
                </div>
              ))}
            </VideoContainer>
          </VideoWrapper>
          <Arrow id="arrow-right"
            src={RightVector}
            alt="next"
            className="right"
            onClick={handleNextVideo}
          />
        </VideoCard>
        <DotsContainer>
            {videoSources.map((_, index) => (
              <Dot
                key={index}
                className={currentVideoIndex === index ? "active" : ""}
                onClick={() => handleDotClick(index)}
              ></Dot>
            ))}
          </DotsContainer>
      </ServicesWrapper>
    </ServicesContainer>
  );
}